import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Form, Col, Radio, FormGroup, ControlLabel, Checkbox } from 'react-bootstrap';
import { Link } from 'react-router';
import BlitzAPI from '../../api/BlitzAPI';

const cellEditProp = {
  mode: 'dbclick',
  blurToSave: true,
};

function chatRoomDataFormat(cell) {
  return (
    <Link to={`/chatrooms/${cell}`}>
      <div>
        {cell}
      </div>
    </Link>
  );
}

function trStyleFormat(row) {
  let outClass;
  switch (row.esport) {
    case 'csgo':
      outClass = 'entry-table-feed';
      break;
    case 'league':
      outClass = 'entry-table-video';
      break;
    default:
      outClass = 'entry-table-default';
  }
  return outClass;
}

export default class ChatRoomTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      query: { object_type: 'raffle,entry,match,lobby', featured_message: false },
      esport: '',
      featured_message: 'false',
    };
    this.onCellEdit = this.onCellEdit.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onTypeChange = this.onTypeChange.bind(this);
    this.onRadioChange = this.onRadioChange.bind(this);
    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  onCellEdit(row, fieldName, value) {
    const { data } = this.state;
    let rowIndex;
    const targetRow = data.find(
      (currentRow, index) => {
        if (currentRow.id === row.id) {
          rowIndex = index;
          return true;
        }
        return false;
      },
    );

    if (targetRow && targetRow[fieldName] !== value) {
      targetRow[fieldName] = value;
      data[rowIndex] = targetRow;
      const chatchannelParams = {};
      chatchannelParams[fieldName] = value;
      BlitzAPI.patchChatRoom(row.id, { chat_channel: chatchannelParams }).then(
        response => console.log(response),
      );
      this.setState({ data });
    }
  }

  onPageChange(page, sizePerPage) {
    const query = Object.assign({}, this.state.query, { page });
    this.setState({ query }, this.getData);
  }

  onSortChange(sortName, sortOrder) {
    const sorting = sortOrder === 'asc' ? sortName : `-${sortName}`;
    const query = Object.assign({}, this.state.query, { order_by: sorting });
    this.setState({
      query,
    }, this.getData);
  }

  onTypeChange(e) {
    const { value, checked } = e.target;
    const currTypes = this.state.query.object_type || '';
    let currTypesList = currTypes.split(',');
    const valueIndex = currTypesList.indexOf(value);
    if (checked && valueIndex === -1) {
      currTypesList.push(value);
    } else if (!checked && valueIndex !== -1) {
      currTypesList.splice(valueIndex, 1);
    }

    currTypesList = currTypesList.filter(x => x);

    const query = Object.assign({}, this.state.query, { object_type: currTypesList.join(',') });
    this.setState({ query }, this.getData);
  }

  onRadioChange(e, field) {
    const { value } = e.target;
    const { query } = this.state;
    let newQuery;
    switch (value) {
      case 'true':
        newQuery = Object.assign({}, query, { [field]: true });
        break;
      case 'false':
        newQuery = Object.assign({}, query, { [field]: false });
        break;
      case '':
        newQuery = Object.assign({}, query);
        delete newQuery[field];
        break;
      default:
        newQuery = Object.assign({}, query, { [field]: value });
    }
    this.setState({ [field]: value });
    this.setState({ query: newQuery }, this.getData);
  }

  getData() {
    const { query } = this.state;
    BlitzAPI.getChatRooms(query).then(
      (resp) => {
        return this.setState({
          data: resp.data.data,
          sizePerPage: resp.data.page_size,
          dataTotalSize: resp.data.total_entries,
          currentPage: resp.data.page_number,
        });
      },
    );
  }

  render() {
    const { esport, featured_message, query } = this.state;

    return (
      this.state.data ?
        <div>
          <div className="container">
            <Form horizontal>
              <Col sm={3}>
                <ControlLabel>Types</ControlLabel>
                <FormGroup>
                  <Checkbox onChange={this.onTypeChange} value="entry" checked={query.object_type.includes('entry')}>Entry</Checkbox>
                  <Checkbox onChange={this.onTypeChange} value="match" checked={query.object_type.includes('match')}>Match</Checkbox>
                  <Checkbox onChange={this.onTypeChange} value="lobby" checked={query.object_type.includes('lobby')}>Lobby</Checkbox>
                  <Checkbox onChange={this.onTypeChange} value="raffle" checked={query.object_type.includes('raffle')}>Raffle</Checkbox>
                </FormGroup>
              </Col>
              <Col sm={3}>
                <ControlLabel>Has Message</ControlLabel>
                <FormGroup>
                  <Radio
                    onChange={e => this.onRadioChange(e, 'featured_message')}
                    value checked={featured_message === 'true'} // eslint-disable-line camelcase
                  >True</Radio>
                  <Radio
                    onChange={e => this.onRadioChange(e, 'featured_message')}
                    value={'false'}
                    checked={featured_message === 'false'} // eslint-disable-line camelcase
                  >All</Radio>
                </FormGroup>
              </Col>
              <Col sm={3}>
                <ControlLabel>Esport</ControlLabel>
                <FormGroup>
                  <Radio
                    onChange={e => this.onRadioChange(e, 'esport')}
                    value="lol" checked={esport === 'lol'} // eslint-disable-line camelcase
                  >League of Legends</Radio>
                  <Radio
                    onChange={e => this.onRadioChange(e, 'esport')}
                    value="csgo" checked={esport === 'csgo'} // eslint-disable-line camelcase
                  >CSGO</Radio>
                  <Radio
                    onChange={e => this.onRadioChange(e, 'esport')}
                    value={''}
                    checked={esport === ''} // eslint-disable-line camelcase
                  >All</Radio>
                </FormGroup>
              </Col>
            </Form>
          </div>
          <BootstrapTable
            data={this.state.data}
            remote striped hover
            cellEdit={cellEditProp}
            pagination
            fetchInfo={{ dataTotalSize: this.state.dataTotalSize }}
            options={{
              onCellEdit: this.onCellEdit,
              onSortChange: this.onSortChange,
              sizePerPage: this.state.sizePerPage,
              onPageChange: this.onPageChange,
              page: this.state.currentPage,
            }}
            trClassName={trStyleFormat}
          >
            <TableHeaderColumn dataSort isKey dataField="id" editable={false} dataFormat={chatRoomDataFormat}>Chat Channel ID</TableHeaderColumn>
            <TableHeaderColumn dataSort dataField="name" width="600">Name</TableHeaderColumn>
            <TableHeaderColumn dataSort dataField="object_id">Object ID</TableHeaderColumn>
            <TableHeaderColumn dataSort dataField="object_type" editable={false}>Object Type</TableHeaderColumn>
            <TableHeaderColumn dataSort dataField="message_count">Message Count</TableHeaderColumn>
          </BootstrapTable>
        </div> : <div><h1>Loading</h1></div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/cms/chat/ChatRoomTable.js